import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ServicesHeader() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        pt: { xs: 15, md: 22 },
        pb: { xs: 10, md: 15 },
      }}
    >
      <Container maxWidth="xl" sx={{ textAlign: "center" }}>
        {/* Subtitle badge */}
        <Typography
          className="reveal-up"
          sx={{
            display: "inline-block",
            px: 3,
            py: 1,
            bgcolor: "rgba(56, 189, 248, 0.1)",
            border: "1px solid rgba(56, 189, 248, 0.2)",
            borderRadius: "100px",
            fontSize: 13,
            color: "#38BDF8",
            letterSpacing: "1px",
            mb: 4,
            fontWeight: 600,
          }}
        >
          همراه مطمئن شما در مسیر تحول دیجیتال
        </Typography>

        {/* Main Hero Headline */}
        <Typography
          className="reveal-up"
          sx={{
            fontSize: { xs: 24, md: 36, lg: 52 },
            fontWeight: 700,
            mb: 4,
            lineHeight: 1.2,
            letterSpacing: "-1px",
            color: "secondary.main",
          }}
        >
          کسب‌وکار خود را با <br />
          <span style={{ color: "#fff" }}>خیال راحت</span> گسترش دهید.
        </Typography>

        {/* Description text */}
        <Typography
          className="reveal-up"
          sx={{
            fontSize: { xs: 14, md: 20 },
            color: "#94A3B8",
            maxWidth: 750,
            mx: "auto",
            lineHeight: 1.8,
            mb: 6,
          }}
        >
          ما اینجا هستیم تا دغدغه‌های فنی شما را به طور کامل برطرف کنیم. از
          طراحی یک وب‌سایت شرکتی باوقار تا توسعه‌ی فروشگاه‌های آنلاین قدرتمند؛
          تا شما بتوانید تمام تمرکز خود را روی فروش و رشد بیزینس بگذارید.
        </Typography>

        {/* Call to Actions */}
        <Box
          className="reveal-up"
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 3,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Box
            onClick={() =>
              scrollTo({
                top: document.getElementById("contact-us").offsetTop - 100,
                behavior: "smooth",
              })
            }
            component="button"
            sx={{
              bgcolor: "secondary.light",
              color: "#05070A",
              border: "none",
              py: 2,
              px: 5,
              borderRadius: "12px",
              fontSize: 16,
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                bgcolor: "secondary.main",
                transform: "translateY(-2px)",
              },
            }}
          >
            شروع پروژه شما
          </Box>
          <Box
            onClick={() => navigate("/projects")}
            component="button"
            sx={{
              bgcolor: "transparent",
              color: "#F8FAFC",
              border: "1px solid rgba(255,255,255,0.2)",
              py: 2,
              px: 5,
              borderRadius: "12px",
              fontSize: 16,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                borderColor: "#fff",
                bgcolor: "rgba(255,255,255,0.05)",
              },
            }}
          >
            مشاهده نمونه‌کارها
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
